import React from "react";

const AtlAndDigital = () => {
  return <div>ATL + DIGITAL PAGE</div>;
};

export default AtlAndDigital;
